import React, { useEffect, useState } from 'react';
import BadgesComponent from '@components/common/Badges';
import './overview.css';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import endpoints from '@config/endpoints';
import axios from '@utils/axiosExt';
import Auth from "../../../../utils/auth";
import { errorLogger } from '@utils/applicationLogUtils';
import isUsingGramPanchayatUtils from '@utils/isUsingGrampanchayatUtil';
interface objectType {
    healthBlockSubDiv: any;
}

const HealthBlockManagementView = (props: objectType) => {
    const { healthBlockSubDiv} = props;
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [healthBlockDetails, setHealthBlockDetails] = useState<any>([]);
    const [ulbByHealthBlockId, setUlbByHealthBlockId] = useState<any>([]);
    const [subDistrictByHealthBlockId, setSubDistrictByHealthBlockId] = useState<any>([]);
    const [blockByHealthBlockId, setBlockByHealthBlockId] = useState<any>([]);
    const [wardByHealthBlockId, setWardByHealthBlockId] = useState<any>([]);
    const [villageByHealthBlockId, setVillageByHealthBlockId] = useState<any>([]);
    const [gramPanchayatByHealthBlockId, setGramPanchayatByHealthBlockId] = useState<any>([]);
    const [isGramPanchayat, setIsGramPanchayat] = useState<boolean>(false);

    useEffect(()=>{
        const fetchData = async () =>{
            try {
                const healthBlockDetail = await axios.get(`${endpoints.getHealthBlockandSubDivByHBSDId(healthBlockSubDiv.id)}`, Auth.loggedIn());
                const healthBlockDetails = healthBlockDetail?.data?.data[0];
                setHealthBlockDetails(healthBlockDetails);
                let grampanchayat:boolean=false;
                const stateCode= healthBlockDetails?.st_code;
                grampanchayat= await isUsingGramPanchayatUtils(stateCode);
                setIsGramPanchayat(grampanchayat);

                const ulbDetail = await axios.get(`${endpoints.getULBbyHbsdId(healthBlockSubDiv?.id)}`, Auth.loggedIn());
                const ulbDetails = ulbDetail?.data?.data;
                setUlbByHealthBlockId(ulbDetails);

                const blockDetail = await axios.get(`${endpoints.getblockHbsdId(healthBlockSubDiv?.id)}`, Auth.loggedIn());
                const blockDetails = blockDetail?.data?.data;
                setBlockByHealthBlockId(blockDetails);

                const subDistDetail = await axios.get(`${endpoints.getSubDistrictbyHbsdId(healthBlockSubDiv?.id)}`, Auth.loggedIn());
                const subDistDetails = subDistDetail?.data?.data;
                setSubDistrictByHealthBlockId(subDistDetails);

                const villageList = await axios.get(`${endpoints.getVillagesByHBSDId(healthBlockSubDiv?.id)}`, Auth.loggedIn());
                const villageDetails = villageList?.data?.data;
                setVillageByHealthBlockId(villageDetails);
                const gramPanchayatList = await axios.get(`${endpoints.getGramPanchayatsByHBSDId(healthBlockSubDiv?.id)}`, Auth.loggedIn());
                const gramPanchayatDetails = gramPanchayatList?.data?.data;
                setGramPanchayatByHealthBlockId(gramPanchayatDetails);

                const wardList = await axios.get(`${endpoints.getWardsByHBSDId(healthBlockSubDiv?.id)}`, Auth.loggedIn());
                const wardDetails = wardList?.data?.data;
                setWardByHealthBlockId(wardDetails);

                setIsLoading(false);
            }  catch(error:any){
                  errorLogger(error?.response?.data||error?.response||error)
            }
        }
        fetchData();
    },[])

    return (
        <>{ isLoading ? <div className="loader">Loading</div> :
            <div className="non-geo-upgrade">
                <div className="overview-healthblock">
                    <BadgesComponent
                        className="over-badge"
                        badgeName={healthBlockSubDiv.type_name==="Sub Division"?"Sub Division Details":"Health Block Details"}
                        variant="primary-1"
                        badgeType="case5"
                    />
                    <div className="overview-healthblock-details">
                        <div className="overview-details-value-type">
                            <label className="overview-details-label">Type</label>
                            <div className='overview-details-label-value'>{healthBlockSubDiv.type_name}</div>
                        </div>
                        <div className="overview-details-value-efd">
                        <label className="overview-details-label">Effective From Date</label>
                            <div className='overview-details-label-value'>{   dayjs(healthBlockDetails?.effective_from_dt)?.format('DD-MM-YYYY')}</div>
                        </div>
                    </div>
                </div>
                <div className="overview-healthblock">
                    <BadgesComponent
                        className="over-badge"
                        badgeName="Location details"
                        variant="primary-1"
                        badgeType="case5"
                    />
                    <div className="overview-location-details">
                        <div className="overview-details-value-dist">
                            
                        <label className="overview-details-label">District</label>
                            <div className='overview-details-label-value'>{`${healthBlockDetails?.district_name}-${healthBlockDetails?.district_code}`} </div>
                        </div>
                        <div className="overview-details-value-hb">
                       <label className="overview-details-label">{healthBlockSubDiv.type_name==="Sub Division"?"Sub Division Name":"Health Block Name"}</label>
                            <div className='overview-details-label-value'>{healthBlockSubDiv.name 
                            }</div>
                        </div>
                        <div className="overview-details-value-subdist">
                            <label className="overview-details-label">Sub District</label>
                            <div className='overview-details-label-value'>{subDistrictByHealthBlockId?.map((subDistrict: any) => `${subDistrict.sub_dist_name}-${subDistrict.sub_dist_code}`).join(', ')
                            }</div>
                        </div>
                        <div className="overview-details-value-block">
                        <label className="overview-details-label">Block</label>
                            <div className='overview-details-label-value'>{blockByHealthBlockId?.map((block: any) => `${block.block_name}-${block.block_code}`).join(', ')
                            }</div>
                        </div>
                        <div className="overview-details-value-ulb">
                      <label className="overview-details-label">ULB</label>
                            <div className='overview-details-label-value'>{ ulbByHealthBlockId?.map((ulb: any) => `${ulb.ulb_name}-${ulb.ulb_code}`).join(', ') 
                            }</div>
                        </div>
                        {!isGramPanchayat?
                        <div  className="overview-details-value-vlgmap">
                        <label className="overview-details-label">Villages Mapped</label>
                            <div className='overview-details-label-value'>{villageByHealthBlockId?.map((village: any) => `${village.village_name}-${village.village_code}`)?.join(', ') 
                            }</div>
                        </div>
                        :
                        <div  className="overview-details-value-vlgmap">
                        <label className="overview-details-label">Gram Panchayat / ADC Village Mapped</label>
                            <div className='overview-details-label-value'>{gramPanchayatByHealthBlockId?.map((gramPanchayat: any) => `${gramPanchayat.gram_panchayat_name}-${gramPanchayat.gram_panchayat_code}`)?.join(', ') 
                            }</div>
                        </div>
                        }
                        <div className="overview-details-value-wardmap">
                        <label className="overview-details-label">Wards Mapped</label>
                            <div className='overview-details-label-value'>{wardByHealthBlockId?.map((ward: any) => `${ward.ward_name}-${ward.ward_code}`)?.join(', ') 
                            }</div>
                        </div>
                    </div>
                </div>
            </div>}
        </>
    );
};
export default HealthBlockManagementView;
